import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import { CustomCheckbox } from 'common-src/components/base';

import styles from './CallItem.module.scss';

const CallItem = ({
  id,
  idPrefix,
  isChecked,
  checkboxHandler,
  icon,
  label,
  client,
  callCreatedAt,
  duration,
}) => {
  const getClientName = (client) => {
    if (!client) return '';
    if (client.id === 1) return 'System user';

    const firstName = client.firstName || '';
    const lastName = client.lastName || '';

    return client.middleName
      ? `${firstName} ${client.middleName.charAt(0)}. ${lastName}`
      : `${firstName} ${lastName}`;
  };

  const getCallCreatedAt = () => {
    const isToday = moment(callCreatedAt).isSame(moment(), 'day');

    if (isToday) {
      return `Today at ${moment(callCreatedAt).format('h:mmA')}`;
    }

    return moment(callCreatedAt).format('MM/DD/YYYY [at] h:mmA');
  };

  const getDuration = () => {
    if (!duration) return '';

    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor(duration / 60) % 60;
    const seconds = Math.ceil(duration % 60);

    return `${hours ? `${hours} hours ` : ''}${minutes ? `${minutes} min ` : ''}${
      seconds ? `${seconds} seconds` : ''
    }`;
  };

  return (
    <div
      className={[
        styles.container,
        isChecked ? styles.checked : '',
        'flex-row',
        'p-12',
        'm-t-16',
        'primary-border',
        'border-r-12',
        'gap-10',
      ].join(' ')}
      role="presentation"
      onClick={checkboxHandler}
    >
      <img className={styles.icon} src={icon} alt="regal-event-icon" />
      <div className="flex-column flex-1 gap-4">
        <span id="provider-name" className={[styles.title, 'font-s-12', 'font-w-600'].join(' ')}>
          {getClientName(client)}
        </span>
        <p className={[styles.content, 'font-w-700'].join(' ')}>
          <span id={`${idPrefix}-channel`} className="font-s-16">
            {label}
          </span>
          <span id={`${idPrefix}-time`} className="font-s-10 m-l-5">
            {getCallCreatedAt()}
          </span>
        </p>
        <span
          id={`${idPrefix}-duration-and-id`}
          className={[styles.addition, 'font-s-10', 'font-w-500'].join(' ')}
        >
          {getDuration()} - ID {id}
        </span>
      </div>
      <CustomCheckbox
        id={`${id}-link-event-checkbox`}
        classNames={[styles.checkbox, 'm-r-20']}
        header={isChecked ? 'Event linked' : 'Link event'}
        onChange={checkboxHandler}
        checked={isChecked}
      />
    </div>
  );
};

CallItem.propTypes = {
  id: PropTypes.string,
  idPrefix: PropTypes.string,
  isChecked: PropTypes.bool,
  checkboxHandler: PropTypes.func,
  icon: PropTypes.string,
  label: PropTypes.string,
  client: PropTypes.object,
  callCreatedAt: PropTypes.string,
  duration: PropTypes.number,
};

export default CallItem;
